import { CloudType } from '@/types/enums';

function getCloudType(cloudType: CloudType | string): string {
  if (cloudType === CloudType.Basic) return '基础版';
  if (cloudType === CloudType.Standard) return '标准版';
  if (cloudType === CloudType.Professional) return '专业版';
  return '免费版';
}

export default getCloudType;
